export default __webpack_public_path__ + "static/media/inactive_delete_icon.1a588fb2.svg";